import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { formMappings } from "../../../../config/formMappings";
import { FormEntry } from "../../../../types/types";

interface TotalTransportationRevenueProps {
  v2Entries: FormEntry[];
}

export default function TotalTransportationRevenue({
  v2Entries,
}: TotalTransportationRevenueProps) {
  const activeFormName = useSelector(
    (state: RootState) => state.activeForm.activeFormName
  );
  const formMapping = formMappings[activeFormName as keyof typeof formMappings];
  const transportationRequestMapping =
    formMapping && "transportationRequest" in formMapping
      ? formMapping.transportationRequest?.fieldMappings
      : undefined;

  // Calculate total revenue from transportation requests (only paid entries)
  const totalTransportationRevenue = v2Entries
    .filter((entry) => {
      if (!transportationRequestMapping) return false;

      // Check if entry is paid
      const paidStatusRaw =
        entry.meta[transportationRequestMapping.paid] ||
        entry.meta["Paid?"] ||
        "No";
      const paidStatus = Array.isArray(paidStatusRaw)
        ? paidStatusRaw[0]
        : paidStatusRaw;
      return paidStatus === "Yes";
    })
    .reduce((total, entry) => {
      if (!transportationRequestMapping) return total;

      // Use totalCost field from transportationRequest mapping
      const totalCostStr =
        entry.meta[transportationRequestMapping.totalCost] || "0";
      const totalCost = parseFloat(
        Array.isArray(totalCostStr) ? totalCostStr[0] : totalCostStr
      );
      return total + (isNaN(totalCost) ? 0 : totalCost);
    }, 0);

  return (
    <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
      <dt className="truncate text-sm font-medium text-gray-500">
        Transportation Revenue
      </dt>
      <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
        $
        {totalTransportationRevenue.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </dd>
    </div>
  );
}
